/**
 * What the `configAttendees` switch means, worded once for the two places an
 * organiser sets it: Settings and the governance create form (TNG-96).
 *
 * Off hides the attendee list and everyone's contact details (email and
 * LinkedIn). It does not hide who somebody is: name, role and company still
 * show wherever the person belongs to something on screen, such as presenters
 * on the agenda, a table's champion, table-mates, and the signals summary
 * PDF. Code that reads the flag should stay inside that meaning.
 */
export const ATTENDEES_MODULE_LABEL = "Attendee list & contact details";

export const ATTENDEES_MODULE_HELP =
  "Off hides the attendee list and everyone's email and LinkedIn. Names, role and company still show where they belong (presenters, champions, table-mates, signals summary).";
